import {SActionBtn, SLowcodeList, SMessage, STableActions} from "shj-components";
import {useRef} from "react";
import {config} from './config.tsx'
import {useNavigate} from "react-router-dom";
import {AddOrEditDom} from "./addOrEdit";
import {useSetState} from "ahooks";
import {orgPermissionsDel, orgPermissionsPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {message} from "antd";
import {findOrgList} from "@/services/externalPerson.ts";
import KeepAlive from "react-activation";

const SalesDataPermission = () => {
  const navigate = useNavigate()
  const listRef = useRef()
  const [state, setState] = useSetState<any>({
    open: false,
    record: {},
    company: [],
  })

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      orgPermissionsPage({params: {pageId: current, pageSize}, data: {...query}}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onDel = (id) => {
    SMessage.delete({
      onOk() {
        return orgPermissionsDel(id).then(res => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      }
    })
  }

  const onAddOrEdit = (record = {}) => {
    setState({open: true, record})
  }

  const onConfigPer = (record) => {
    navigate(`/saleOp/saleConfig/salesDataPermission/${record.id}?orgId=${record.orgId}`)
  }

  const getStatusOptions = async () => {
    const pageEnums = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.clue.PageEnum')
    const company = await findOrgList()
    setState({company})
    return Promise.resolve({pageEnums, company})
  }

  const extension = {
    request: {fetchList, getStatusOptions},
    events: {onAdd: () => onAddOrEdit()},
    searchMode: 'group',
    customRender: {
      actionRender(_, record) {
        return <STableActions>
          <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
          <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
          <SActionBtn onClick={() => onConfigPer(record)}>人员配置</SActionBtn>
        </STableActions>
      }
    }
  }

  return <>
    <SLowcodeList ref={listRef} config={config} {...extension} />
    {state.open && <AddOrEditDom {...state} setOpen={(open) => setState({open})} reload={listRef.current?.reload}/>}
  </>
}

export default function SalesDataPermissionPage() {
  return (
    <KeepAlive name={location.pathname}>
      <div>
        <SalesDataPermission />
      </div>
    </KeepAlive>
  )
}